import axios from "axios";
import { useState, useEffect } from "react";
import Navbar from "../components/Navbar";

import API from "../config.js";
const G   = "#FFB800";
const G2  = "#FFD700";
const GD  = "#C8860A";

const LEVEL_COLORS = [
  "#FFD700","#FFB800","#FF9900",
  "#00C2FF","#00C2FF","#B8A0FF",
  "#B8A0FF","#C0C8D8","#C0C8D8","#C0C8D8",
];

export default function Downline() {
  const [downline, setDownline]   = useState([]);
  const [openLevels, setOpenLevels] = useState({ 1: true });
  const [pageLoad, setPageLoad]   = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [commission, setCommission] = useState(null);

  const token   = localStorage.getItem("token");
  const headers = { Authorization: "Bearer " + token };

  useEffect(() => {
    if (!token) { window.location.href = "/"; return; }
    axios.get(`${API}/api/downline`, { headers })
      .then(res => {
        setDownline(res.data);
        setTotalCount(res.data.reduce((a, l) => a + l.members.length, 0));
      })
      .catch(err => {
        if (err.response?.status === 401) { localStorage.removeItem("token"); window.location.href = "/"; }
      })
      .finally(() => setPageLoad(false));

    axios.get(`${API}/api/referral-commissions`, { headers })
      .then(res => setCommission(res.data))
      .catch(() => {});
  }, []);

  const fmt = (n) => (Number(n) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const fmtDate = (d) => d ? new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short" }) : "—";

  const toggle = (lvl) => setOpenLevels(prev => ({ ...prev, [lvl]: !prev[lvl] }));

  if (pageLoad) return (
    <div style={s.page}>
      <Navbar />
      <div style={{ display:"flex", justifyContent:"center", alignItems:"center", height:"70vh" }}>
        <div style={s.spinner} />
      </div>
    </div>
  );

  return (
    <div style={s.page}>
      <Navbar />
      <div style={s.container} className="page-container">

        {/* Header */}
        <div style={s.header} className="page-header">
          <div>
            <h1 style={s.title}>My Network</h1>
            <p style={s.sub}>Your complete downline — up to 10 levels deep</p>
          </div>
          <div style={s.statsPills}>
            <div style={s.pill}>
              <span style={s.pillLbl}>Total Members</span>
              <span style={s.pillVal}>{totalCount}</span>
            </div>
            <div style={{ ...s.pill, borderColor:"rgba(0,194,255,0.3)" }}>
              <span style={s.pillLbl}>Active Levels</span>
              <span style={{ ...s.pillVal, color:"#00C2FF" }}>{downline.length}</span>
            </div>
          </div>
        </div>

        {/* ── Referral Commission Section ── */}
        {commission && commission.summary.totalEarned > 0 && (
          <div style={s.commWrap}>
            <div style={s.commHeadRow}>
              <h2 style={s.commTitle}>💰 Referral Commission</h2>
              <span style={s.commHint}>10% per referral invest · released 2% every 2 days while they stay invested</span>
            </div>

            <div style={s.commStats}>
              <div style={{ ...s.commStat, borderColor: "rgba(255,184,0,0.3)" }}>
                <span style={s.commStatLbl}>Total Earned</span>
                <span style={{ ...s.commStatVal, color: G2 }}>{fmt(commission.summary.totalEarned)}</span>
                <span style={s.commStatUnit}>USDT</span>
              </div>
              <div style={{ ...s.commStat, borderColor: "rgba(0,232,122,0.3)" }}>
                <span style={s.commStatLbl}>Paid to Wallet</span>
                <span style={{ ...s.commStatVal, color: "#00e87a" }}>{fmt(commission.summary.totalPaid)}</span>
                <span style={s.commStatUnit}>USDT</span>
              </div>
              <div style={{ ...s.commStat, borderColor: "rgba(0,194,255,0.3)" }}>
                <span style={s.commStatLbl}>Pending</span>
                <span style={{ ...s.commStatVal, color: "#00C2FF" }}>{fmt(commission.summary.totalPending)}</span>
                <span style={s.commStatUnit}>USDT</span>
              </div>
            </div>

            <div style={s.commList}>
              {commission.schedules.map((sc, i) => {
                const pct = Math.round((sc.paidCount / sc.totalInstallments) * 100);
                const statusColor = sc.status === "completed" ? "#00e87a" : sc.status === "cancelled" ? "#ff6b6b" : "#00C2FF";
                const statusLabel = sc.status === "completed" ? "Completed" : sc.status === "cancelled" ? "Stopped" : "In Progress";
                return (
                  <div key={i} style={s.commItem}>
                    <div style={s.commItemTop}>
                      <span style={s.commEmail}>{sc.downlineEmail}</span>
                      <span style={{ ...s.commBadge, color: statusColor, borderColor: statusColor + "55" }}>{statusLabel}</span>
                    </div>
                    <div style={s.commItemMid}>
                      <span style={s.commSmall}>Invested <b style={{ color: "#e0e8ff" }}>{fmt(sc.investAmount)}</b> → 10% = <b style={{ color: G2 }}>{fmt(sc.fullCommission)} USDT</b></span>
                    </div>
                    {/* progress bar */}
                    <div style={s.commBarTrack}>
                      <div style={{ ...s.commBarFill, width: `${pct}%`, background: statusColor }} />
                    </div>
                    <div style={s.commItemBot}>
                      <span style={s.commSmall}>{sc.paidCount}/{sc.totalInstallments} installments · {fmt(sc.perInstallment)} each</span>
                      {sc.status === "active" && <span style={s.commSmall}>Next: {fmtDate(sc.nextDueDate)}</span>}
                      {sc.status === "cancelled" && <span style={{ ...s.commSmall, color: "#ff6b6b" }}>{fmt(sc.cancelled)} cancelled (they withdrew)</span>}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {downline.length === 0 ? (
          <div style={s.emptyCard}>
            <div style={s.emptyIcon}>🌱</div>
            <div style={s.emptyTitle}>No referrals yet</div>
            <p style={s.emptySub}>Share your referral link to start building your network and earn multi-level commissions.</p>
          </div>
        ) : (
          <div style={s.treeWrap}>
            {downline.map(({ level, members }) => {
              const color   = LEVEL_COLORS[level - 1] || G;
              const isOpen  = openLevels[level];
              const depPct  = [10,5,3,2,1,1,0.5,0.5,0.3,0.3][level-1];
              const invPct  = [0.2,0.15,0.1,0.05,0.03,0.03,0.03,0.03,0.03,0.03][level-1];
              const totalDep = members.reduce((a, m) => a + (m.totalDeposit || 0), 0);

              return (
                <div key={level} style={s.levelBlock}>
                  {/* Level header */}
                  <button style={{ ...s.levelHead, borderColor: color + "35" }} onClick={() => toggle(level)}>
                    <div style={s.levelLeft}>
                      <span style={{ ...s.levelBadge, background: color + "15", color, borderColor: color + "30" }}>
                        L{level}
                      </span>
                      <div>
                        <span style={{ ...s.levelName, color }}>
                          {level === 1 ? "Direct Referrals" : `Level ${level}`}
                        </span>
                        <span style={s.levelMeta}>
                          {members.length} member{members.length !== 1 ? "s" : ""}
                          &nbsp;·&nbsp;Deposit: {depPct}% · Daily invest: {invPct}%
                        </span>
                      </div>
                    </div>
                    <div style={s.levelRight}>
                      <span style={{ ...s.levelTotal, color }}>
                        Total deposited: {fmtU(totalDep)}
                      </span>
                      <span style={{ ...s.chevron, transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}>▾</span>
                    </div>
                  </button>

                  {/* Members list */}
                  {isOpen && (
                    <div style={s.membersList}>
                      {members.map((m, i) => (
                        <div key={i} style={{ ...s.memberRow, borderLeft: `2px solid ${color}30` }}>
                          <div style={{ ...s.mAvatar, background: color + "15", color, borderColor: color + "30" }}>
                            {(m.name || "U")[0].toUpperCase()}
                          </div>
                          <div style={s.mInfo}>
                            <span style={s.mName}>{m.name || "—"}</span>
                            <span style={s.mEmail}>{maskEmail(m.email)}</span>
                          </div>
                          <div style={s.mStats}>
                            <span style={s.mStatItem}>
                              <span style={s.mStatLbl}>Deposited</span>
                              <span style={{ ...s.mStatVal, color: "#00e87a" }}>{fmtU(m.totalDeposit)}</span>
                            </span>
                            <span style={s.mStatItem}>
                              <span style={s.mStatLbl}>Joined</span>
                              <span style={s.mStatVal}>{m.joinDate ? new Date(m.joinDate).toLocaleDateString("en-IN",{day:"2-digit",month:"short",year:"numeric"}) : "—"}</span>
                            </span>
                            <span style={{ ...s.mStatus, background: m.isBlocked ? "rgba(255,107,107,0.1)" : "rgba(0,232,122,0.1)", color: m.isBlocked ? "#ff6b6b" : "#00e87a", borderColor: m.isBlocked ? "#ff6b6b33" : "#00e87a33" }}>
                              {m.isBlocked ? "Blocked" : "Active"}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

function maskEmail(email = "") {
  const [user, domain] = email.split("@");
  if (!domain) return email;
  return user.slice(0, 2) + "***@" + domain;
}

const fmtU = v => "USDT " + (Number(v) || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const s = {
  page:      { minHeight:"100vh", background:"#060D1A" },
  container: { maxWidth:1000, margin:"0 auto", padding:"32px 24px" },
  header:    { display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:28, flexWrap:"wrap", gap:16 },
  title: {
    fontFamily:"'Figtree',sans-serif", fontWeight:700, fontSize:26,
    background:`linear-gradient(135deg,#f0e0a0,${G},${GD})`,
    WebkitBackgroundClip:"text", WebkitTextFillColor:"transparent",
    letterSpacing:2, marginBottom:6,
  },
  sub: { fontFamily:"'-apple-system','BlinkMacSystemFont','Figtree',sans-serif", fontSize:14, color:"rgba(160,180,220,0.45)" },
  statsPills: { display:"flex", gap:12 },
  pill: {
    background:"rgba(255,184,0,0.07)", border:"1px solid rgba(255,184,0,0.2)",
    borderRadius:12, padding:"12px 20px", textAlign:"center",
  },
  pillLbl: { display:"block", fontFamily:"'-apple-system','BlinkMacSystemFont','Figtree',sans-serif", fontSize:10, color:"rgba(255,184,0,0.5)", letterSpacing:1.5, textTransform:"uppercase", marginBottom:4 },
  pillVal: { fontFamily:"'Figtree',sans-serif", fontWeight:700, fontSize:20, color:G2 },

  emptyCard: {
    background:"rgba(8,18,40,0.95)", border:"1px solid rgba(255,184,0,0.1)",
    borderRadius:16, padding:"60px 32px", textAlign:"center",
  },
  emptyIcon:  { fontSize:48, marginBottom:16 },
  emptyTitle: { fontFamily:"'Figtree',sans-serif", fontWeight:700, fontSize:18, color:"#e0e8ff", marginBottom:12 },
  emptySub:   { fontFamily:"'-apple-system','BlinkMacSystemFont','Figtree',sans-serif", fontSize:14, color:"rgba(160,180,220,0.4)", maxWidth:400, margin:"0 auto", lineHeight:1.6 },

  treeWrap: { display:"flex", flexDirection:"column", gap:10 },

  levelBlock: {
    background:"rgba(8,18,40,0.95)", border:"1px solid rgba(255,184,0,0.08)",
    borderRadius:12, overflow:"hidden",
  },
  levelHead: {
    display:"flex", justifyContent:"space-between", alignItems:"center",
    padding:"16px 20px", background:"none", border:"none",
    borderBottom:"1px solid",
    cursor:"pointer", width:"100%", textAlign:"left",
    transition:"background 0.2s",
  },
  levelLeft:  { display:"flex", alignItems:"center", gap:12 },
  levelBadge: {
    fontFamily:"'Figtree',sans-serif", fontWeight:700, fontSize:11,
    border:"1px solid", borderRadius:6, padding:"4px 10px", flexShrink:0,
  },
  levelName: { display:"block", fontFamily:"'Figtree',sans-serif", fontWeight:700, fontSize:13, letterSpacing:0.5 },
  levelMeta: { display:"block", fontFamily:"'-apple-system','BlinkMacSystemFont','Figtree',sans-serif", fontSize:11, color:"rgba(160,180,220,0.4)", marginTop:2 },
  levelRight: { display:"flex", alignItems:"center", gap:16 },
  levelTotal: { fontFamily:"'Figtree',sans-serif", fontSize:11, fontWeight:700 },
  chevron: { color:"rgba(255,184,0,0.5)", fontSize:16, transition:"transform 0.2s", display:"block" },

  membersList: { padding:"8px 0" },
  memberRow: {
    display:"flex", alignItems:"center", gap:12,
    padding:"10px 20px 10px 24px",
    borderBottom:"1px solid rgba(255,184,0,0.04)",
    marginLeft:16,
  },
  mAvatar: {
    width:34, height:34, borderRadius:"50%", border:"1px solid",
    display:"flex", alignItems:"center", justifyContent:"center",
    fontFamily:"'Figtree',sans-serif", fontWeight:700, fontSize:13, flexShrink:0,
  },
  mInfo: { flex:1, display:"flex", flexDirection:"column", gap:2 },
  mName: { fontFamily:"'-apple-system','BlinkMacSystemFont','Figtree',sans-serif", fontWeight:600, fontSize:13, color:"#e0e8ff" },
  mEmail: { fontFamily:"'-apple-system','BlinkMacSystemFont','Figtree',sans-serif", fontSize:11, color:"rgba(160,180,220,0.35)" },
  mStats: { display:"flex", alignItems:"center", gap:16 },
  mStatItem: { display:"flex", flexDirection:"column", alignItems:"flex-end" },
  mStatLbl: { fontFamily:"'-apple-system','BlinkMacSystemFont','Figtree',sans-serif", fontSize:9, color:"rgba(160,180,220,0.35)", textTransform:"uppercase", letterSpacing:1 },
  mStatVal: { fontFamily:"'Figtree',sans-serif", fontSize:11, fontWeight:700, color:"rgba(224,232,255,0.7)" },
  mStatus: {
    fontFamily:"'-apple-system','BlinkMacSystemFont','Figtree',sans-serif", fontSize:10, fontWeight:600,
    border:"1px solid", borderRadius:20, padding:"3px 10px",
  },

  spinner: {
    width:40, height:40, border:"3px solid rgba(255,184,0,0.15)",
    borderTop:`3px solid ${G}`, borderRadius:"50%",
    animation:"spin 0.8s linear infinite",
  },

  /* Referral commission */
  commWrap: {
    background:"rgba(8,18,40,0.6)", border:"1px solid rgba(255,184,0,0.15)",
    borderRadius:16, padding:"20px 22px", marginBottom:24,
  },
  commHeadRow: { display:"flex", flexWrap:"wrap", alignItems:"baseline", gap:10, marginBottom:16 },
  commTitle: { fontFamily:"'Figtree',sans-serif", fontSize:18, fontWeight:800, color:"#e8eefc", margin:0 },
  commHint: { fontFamily:"'-apple-system','Figtree',sans-serif", fontSize:11, color:"rgba(160,180,220,0.5)" },
  commStats: { display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:12, marginBottom:18 },
  commStat: {
    display:"flex", flexDirection:"column", gap:2,
    background:"rgba(0,0,0,0.25)", border:"1px solid rgba(255,184,0,0.2)",
    borderRadius:12, padding:"14px 16px",
  },
  commStatLbl: { fontFamily:"'-apple-system','Figtree',sans-serif", fontSize:11, color:"rgba(160,180,220,0.55)", textTransform:"uppercase", letterSpacing:0.5 },
  commStatVal: { fontFamily:"'Figtree',sans-serif", fontSize:24, fontWeight:800, lineHeight:1.1 },
  commStatUnit: { fontFamily:"'-apple-system','Figtree',sans-serif", fontSize:10, color:"rgba(160,180,220,0.4)" },
  commList: { display:"flex", flexDirection:"column", gap:10 },
  commItem: {
    background:"rgba(0,0,0,0.2)", border:"1px solid rgba(255,184,0,0.08)",
    borderRadius:10, padding:"12px 14px",
  },
  commItemTop: { display:"flex", justifyContent:"space-between", alignItems:"center", gap:8, marginBottom:6 },
  commEmail: { fontFamily:"'-apple-system','Figtree',sans-serif", fontSize:13, fontWeight:600, color:"#cdd8f0", wordBreak:"break-all" },
  commBadge: {
    fontFamily:"'-apple-system','Figtree',sans-serif", fontSize:10, fontWeight:700,
    border:"1px solid", borderRadius:20, padding:"3px 10px", whiteSpace:"nowrap",
  },
  commItemMid: { marginBottom:8 },
  commSmall: { fontFamily:"'-apple-system','Figtree',sans-serif", fontSize:12, color:"rgba(160,180,220,0.6)" },
  commBarTrack: { height:6, background:"rgba(255,255,255,0.06)", borderRadius:4, overflow:"hidden", marginBottom:8 },
  commBarFill: { height:"100%", borderRadius:4, transition:"width 0.4s ease" },
  commItemBot: { display:"flex", justifyContent:"space-between", flexWrap:"wrap", gap:6 },
};


